import React from 'react'
import Container from 'container'
import { Router } from '@reach/router'
import ReactDOM from 'react-dom'
import './index.css'
import 'assets/theme/css/App.css'
import * as serviceWorker from './serviceWorker'
import { store } from 'context'
import { Provider } from 'react-redux'
import Loader from 'assets/theme/components/Loader'
import theme from 'assets/theme'
import { ThemeProvider } from '@mui/material/styles';
const Login = React.lazy(() => import('pages/Login'))
const OtpContainer = React.lazy(() => import('pages/Otp/otpContainer'))
const ImmediateSolicitude = React.lazy(() => import('pages/ImmediateSolicitude'))
const ProblemsPage = React.lazy(() => import('components/problemPage'))
const Error404 = React.lazy(() => import('pages/404'))


/* Typescript allow design system */
declare global {
  export namespace JSX {
    // tslint:disable-next-line: no-empty-interface
    export interface Element {
      [tagName: string]: any
    }
    export interface IntrinsicElements {
      [tagName: string]: any
    }
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <React.Suspense fallback={<Loader />}>
          <Router primary={false}>
            <Container path="/:flujo/login">
              <Login path="/" />
              <Login path="/:adviser" />
              <OtpContainer path="/otp" />
              <ImmediateSolicitude path="/solicitud" />
            </Container>
            <ProblemsPage code={'20000'} message={''} path="/volveremos" />
            <Error404 path="/404" default={true} />
          </Router>
        </React.Suspense>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// serviceWorker
serviceWorker.unregister()
